import axios from '@axios';

// No catch/fallback: authorization and transport errors remain rejected.
export default async function carregarAtendimento(pedidoId) {
  const response = await axios.get(`/pedido-venda/atendimento/${encodeURIComponent(pedidoId)}`);
  const payload = response.data;
  if (!payload || typeof payload.disponivel !== 'boolean'
      || (payload.disponivel && (!payload.resumo || !Array.isArray(payload.etapas)))) {
    throw new Error('Resposta de atendimento inválida.');
  }
  return payload;
}